module.exports = require("babel-runtime/core-js/reflect/delete-property");


/*****************
 ** WEBPACK FOOTER
 ** external "babel-runtime/core-js/reflect/delete-property"
 ** module id = 6
 ** module chunks = 0
 **/